import React from 'react';

import { Snackbar } from '@mui/material/';

import { ReactComponent as AlertIcon } from '../../../assets/icons/alert-color-icon-ne.svg';
import { ReactComponent as ErrorIcon } from '../../../assets/icons/error-color-icon-ne.svg';
import { ReactComponent as InfoIcon } from '../../../assets/icons/info-color-icon-ne.svg';
import { ReactComponent as SuccessIcon } from '../../../assets/icons/success-color-icon-ne.svg';
import { IToastProps } from '../../interfaces/toast';
import { CARD_STATUS_TYPES } from '../../types/errorHandlingTypes';
import StyledButton from '../StyledButton/StyledButton';

import './ToastNE.scss';

const ToastNE = ({ button, buttonText, description, icon, title, open, buttonAction, handleClose }: IToastProps) => {
  const TOASTS_NE_ICONS = {
    success: <SuccessIcon data-testid="success-icon" />,
    error: <ErrorIcon data-testid="error-icon" />,
    informative: <InfoIcon data-testid="info-icon" />,
    alert: <AlertIcon data-testid="alert-icon" />
  };

  const image = TOASTS_NE_ICONS[icon as CARD_STATUS_TYPES] ?? null;

  return (
    <div data-experience="new">
      <Snackbar
        className={`snackbar ${icon} fixed left-8 bottom-8 flex rounded-lg`}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
        open={open}
        onClose={handleClose}
      >
        <div className="toast m-4 flex">
          {icon && <div className="mr-2">{image}</div>}
          <div className="w-full text-left">
            {title && <div className="toast-title-font leading-5 mb-2 pt-0\.5">{title}</div>}
            <div className="toast-description-font">{description}</div>
          </div>
          {button && (
            <StyledButton
              buttonType="tertiary"
              classes="toast-btn w-auto m-auto ml-2 cursor-pointer"
              action={buttonAction}
            >
              {buttonText}
            </StyledButton>
          )}
        </div>
      </Snackbar>
    </div>
  );
};

export default ToastNE;
